import React from 'react';
import Image from '../../images/footer_img.svg';

import './styles.scss';

const FooterCta = () => {
  return (
    <>
      <section>
        <div className="footer_cta container">
          <div className="footer_cta_left">
            <div className="footer_cta_left_inner">
              <h2 className="footer_cta_left_h2">
                A contabilidade do futuro é uma{' '}
                <strong>Contabilidade digital</strong> e{' '}
                <strong>Estratégica</strong>
              </h2>
              <p className="footer_cta_left_p">
                Inicie agora o seu cadastro digital ou converse com nossos
                especialistas contábeis.
              </p>
              <div className="footer_cta_left_div">
                <a
                  href="https://conteudo.simplesja.com.br/abrir-minha-empresa-trocar-de-contador"
                  className="footer_cta_left_div_a extra"
                >
                  Abrir empresa
                </a>
                <a
                  href="https://conteudo.simplesja.com.br/fale-com-especialista"
                  className="footer_cta_left_div_a"
                >
                  Falar com especialista
                </a>
              </div>
            </div>
          </div>
          <div className="footer_cta_right">
            <img className="footer_cta_right_img" src={Image} alt="" />
          </div>
        </div>
      </section>
    </>
  );
};

export default FooterCta;
